module.exports = __webpack_public_path__ + "static/media/MSLearn.cdbb74bd.png";